export default {
  collisionColor: '#FDC280',
  dimensionsColor: '#1EBBF0',
  gableColor: '#000',
  highlightFillColor: '#00D2FF',
  highlightStrokeColor: 'rgba(30, 187, 240, .7)',
  inventoryBoxFillColor: '#1E1E1C',
  inventoryDimensionsColor: '#D74B35',
  inventoryFillColor: '#7E7E7E',
  roomBorderColor: '#CECEC9',
  selectedItemFillColor: 'rgba(30, 187, 240, .8)',
  wallsColor: '#CECEC9'
}
